import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';


import ScheduleBoxOption from './ScheduleBoxOption';

module.exports = class MeasurementBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            IsActive: this.props.isActive
        }

        this.onChange = this.onChange.bind(this);
    }

    changeValues(isActive) {
        this.setState({
            IsActive: isActive
        });

        this.chbIsActive.setChecked(isActive);
    }

    onChange(id, isActive) {
        this.setState({
            IsActive: isActive
        });
    }

    render() {
        var checkboxID = this.props.ID + "IsChecked";
        var childrenDiv = (this.state.IsActive == false ? 'hidden' : '');
        return (
            <div className='treatmentBox'>
                <div className='treatmentBoxHeader'>
                    <div className='col-xs-9'>
                        <CheckBox id={checkboxID} ref={(chbIsActive) => { this.chbIsActive = chbIsActive; }} onChange={this.onChange} />
                        <h4>Measurements</h4>
                    </div>
                    <div className='col-xs-2 reset'>
                        Reset
                        </div>
                </div>
                <div className={childrenDiv}>
                    <div className='treatmentBoxOption white'>
                        <div className='row measurmentsIcons'>
                            <div className='col-xs-4'>
                                <div>
                                    <img src='/gallery/doctorAdvice/humidity_icon.png' />
                                </div>
                                Humidity
                        </div>
                            <div className='col-xs-4'>
                                <div>
                                    <img src='/gallery/doctorAdvice/sebum_icon.png' />
                                </div>
                                Sebum
                        </div>
                            <div className='col-xs-4'>
                                <div>
                                    <img src='/gallery/doctorAdvice/elasticity_icon.png' />
                                </div>
                                Elasticity
                        </div>
                        </div>
                    </div>
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/doctorAdvice/MeasurementBox.jsx